<template>
  <div class="part changer customer-changer" @click="onSelectCustomer">
    <div class="display" v-if="customer">
      <div class="name">{{ customer.name || 'n/a' }} {{ customer.last_name || '' }}</div>
      <div class="id">{{ customer._id ? '(' + customer._id + ')' : '' }}</div>
    </div>
    <div class="selection" v-else>
      <div class="missing">Missing Customer</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'customer-changer',
  props: ['customer'],
  methods: {
    onSelectCustomer() {
      this.$store.dispatch('crm/open', 'SELECT_CUSTOMER')
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-changer {
  .display {
    display: flex;
  }

  .missing {
    color: red;
  }
}
</style>
